// extracted by mini-css-extract-plugin
export default {"background":"main_background__Uswqs","wrapper":"main_wrapper__ovsiC","titleContainer":"main_titleContainer__0dDTi","subtitleContainer":"main_subtitleContainer__NsqfD"};